<template>
  <div class="ProvisionalAuthorization">
    <div class="ProvisionalAuthorization-title">
      <img src="/static/img/ProvisionalAuthorizationIcon.png" />
      <span>{{$t('system_approvalset_provisionalauthorization_linshishenpishouquan')}}</span>
    </div>
    <div class="ProvisionalAuthorization-wrapper">
      <div class="ProvisionalAuthorization-item">
        <div @click="SelectEmployee">
          <span class="ellipsis" v-if="selectedText.length > 0">{{ selectedText[0].label }}</span>
          <span class="ellipsis" v-else>{{$t('system_approvalset_provisionalauthorization_qingxuanze')}}</span>
        </div>
        <div>{{$t('system_approvalset_provisionalauthorization_shouquanyuangong')}}</div>
        <div>
          <img src="/static/img/left1.png" />
        </div>
      </div>
      <div class="border_bottom"></div>
      <div class="ProvisionalAuthorization-item">
        <div @click="showCalendar(0, 'ConferDate')">
          <span class="ellipsis">{{ value.ConferDate }}</span>
        </div>
        <div>{{$t('system_approvalset_provisionalauthorization_kaishiriqi')}}</div>
        <div>
          <img src="/static/img/left1.png" />
        </div>
      </div>
      <div class="border_bottom"></div>
      <div class="ProvisionalAuthorization-item">
        <div @click="SelectTime">
          <span class="ellipsis">{{ value.time }}</span>
        </div>
        <div>{{$t('system_approvalset_provisionalauthorization_xuanzeshijian')}}</div>
        <div>
          <img src="/static/img/left1.png" />
        </div>
      </div>
      <div class="border_bottom"></div>
      <div class="ProvisionalAuthorization-item">
        <div style="line-height:1">
          <label v-for="durationType in durationTypes" :key="durationType.value">
            <input
              @change="ChangeType(value.durationType, value.sliderValue)"
              style="vertical-align: middle;"
              :label="durationType.label"
              type="radio"
              :value="durationType.value"
              v-model="value.durationType"
            />
            <span style="vertical-align: middle;">{{ durationType.label }}</span>
          </label>
          <span>
            <a>{{$t('system_approvalset_provisionalauthorization_jiezhishijian')}}</a>
            <a style="width: 2.394rem;display: inline-block;">{{ ExpiryDate }}</a>
          </span>
        </div>
        <div>{{$t('system_approvalset_provisionalauthorization_shouquanshichang')}}</div>
      </div>
      <div class="border_bottom"></div>
      <div class="ProvisionalAuthorization-item">
        <div v-if="value.durationType == 'hours'">
          <range v-model="value.sliderValue" :min="0" :max="24" :step="1" :bar-height="5" style="width:2rem"></range>
          <span class="ellipsis">{{ value.sliderValue }}<span>{{$t('system_approvalset_provisionalauthorization_xiaoshi')}}</span></span>
        </div>
        <div v-if="value.durationType == 'day'">
          <range v-model="value.sliderValue" :min="0" :max="15" :step="1" :bar-height="5" style="width:2rem"></range>
          <span class="ellipsis">{{ value.sliderValue }}<span>{{$t('system_approvalset_provisionalauthorization_tian')}}</span></span>
        </div>
        <div></div>
      </div>
      <slot></slot>
    </div>
    <picker @select="handleSelect(0, arguments)" ref="picker" :cancelTxt="cancelTxt" :confirmTxt="confirmTxt"></picker>
    <calendar @change="changeDate" :data="calendarData" :monthScope="monthScope" ref="calendar0"></calendar>
    <timePicker @select="handleSelectTime(0, arguments)" :data="AllDates" ref="timePicker" :cancelTxt="cancelTxt" :confirmTxt="confirmTxt"></timePicker>
  </div>
</template>
<style scoped>
  .ProvisionalAuthorization-title {
    background-color: #fff;
    height: 1.330rem;
    line-height: 1.330rem;
    padding: 0 0.399rem;
    border-top-left-radius: 0.266rem;
    border-top-right-radius: 0.266rem;
  }

  .ProvisionalAuthorization-title img {
    width: 0.399rem;
    vertical-align: middle;
  }

  .ProvisionalAuthorization-title span {
    vertical-align: middle;
    font-size: 0.425rem;
  }

  .ProvisionalAuthorization-wrapper {
    padding-left: 0.399rem;
    background-color: #fff;
    border-bottom-left-radius: 0.266rem;
    border-bottom-right-radius: 0.266rem;
  }

  .ProvisionalAuthorization-item {
    position: relative;
    font-size: 0.372rem;
  }

  .ProvisionalAuthorization-item > div {
    height: 1.330rem;
    /* line-height: 1.330rem; */
    display: flex;
    align-items: center;
    text-align: left;
  }

  .ProvisionalAuthorization-item > div:first-child {
    margin-left: 1.995rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 0.29rem;
  }

  .ProvisionalAuthorization-item > div:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    width: 1.995rem;
  }

  .ProvisionalAuthorization-item > div:nth-child(3) {
    position: absolute;
    top: 0;
    right: 0.399rem;
    height: 1.330rem;
    line-height: 1.330rem;
  }

  .ProvisionalAuthorization-item img {
    width: 0.372rem;
    vertical-align: text-top;
  }
</style>
<script>
  import timePicker from "../modules/time-picker.vue";
  import picker from "../modules/picker.vue";
  import range from "../modules/range.vue";
  import calendar from "../modules/calendar.vue";
  export default {
    data() {
      return {
        cancelTxt: "share.cancelTxt",
        confirmTxt: "share.confirmTxt",
        selectedText: [],
        calendarData: [],
        durationTypes: [
          {
            label: this.$root.$t('system_approvalset_provisionalauthorization_shi') ,
            value: "hours",
          },
          {
            label: this.$root.$t('system_approvalset_provisionalauthorization_tian') ,
            value: "day",
          },
        ],
        monthScope: 3,
        selectedTimePickerText: ["00", "00"],
        selectedTImePickerIndex: [[0, 0]],
        AllDates: [
          {
            minDate: 0,
            maxDate: 24,
          },
          {
            minDate: 0,
            maxDate: 60,
          },
        ],
      };
    },
    props: ["value", "Companys"],
    computed: {
      ExpiryDate() {
        let __self = this;
        let result = moment().format("MM-DD HH:mm");
        if (__self.value.durationType == "hours") {
          result = moment(__self.value.ConferDate + " " + __self.value.time).add(__self.value.sliderValue, "hours");
        } else {
          result = moment(__self.value.ConferDate + " " + __self.value.time).add(__self.value.sliderValue, "days");
        }
        __self.value.ExpiryDate = result;
        return result.format("MM-DD HH:mm");
      },
    },
    mounted() {
      let __self = this;
      __self.calendarData = [
        {
          title: __self.$t("system.DateGranted"),
          value: moment(__self.value.ConferDate).format("YYYY-MM-DD"),
          maxDate: moment()
            .add(3, "months")
            .format("YYYY-MM-DD"),
          minDate: moment().format("YYYY-MM-DD"),
          key: "ConferDate",
          isSelected: true,
          isScope: true,
        },
      ];
      if (__self.Companys.length > 0 && __self.value.OwnerID != "") {
        let result = _.findIndex(__self.Companys, function(o) {
          return o.RoleID == __self.value.OwnerID;
        });
        if (result < 0) {
          result = 0;
          __self.$refs.picker.setSelectedIndex([result]);
          __self.selectedText.push(__self.Companys[result]);
        } else {
          __self.$refs.picker.setSelectedIndex([result]);
          __self.selectedText.push(__self.Companys[result]);
        }
        __self.$refs.picker.setData([__self.Companys]);
      }
      __self.selectedTimePickerText = __self.value.time.split(":");
      __self.$refs.timePicker.setSelectedIndex(__self.selectedTimePickerText);
      __self.$refs.calendar0.setData(__self.calendarData);
    },
    methods: {
      SelectEmployee() {
        let __self = this;
        __self.$refs.picker.show();
      },
      handleSelect(index, args) {
        let __self = this;
        __self.selectedText.splice(index, 1, args[2][0]);
        __self.value.OwnerID = __self.selectedText[0].value;
      },
      handleSelectTime(index, args) {
        let __self = this;
        __self.value.time = args[0].join(":");
      },
      changeDate(datas) {
        let __self = this;
        for (let i = 0; i < datas.length; i++) {
          __self.value[datas[i].key] = datas[i].value;
        }
        let time = moment(__self.value.ConferDate).day() - moment().day();
        if (time > 0) {
          __self.value.time = "00:00";
        } else {
          __self.value.time = moment().hour() + ":00";
        }
        __self.selectedTimePickerText = __self.value.time.split(":");
      },
      showCalendar(index, value) {
        let __self = this;
        let calendar = __self.$refs["calendar" + index];
        for (let i = 0; i < __self.calendarData.length; i++) {
          let data = __self.calendarData[i];
          data.isSelected = data.key == value;
        }
        calendar.show();
      },
      ChangeType(type, sliderValue) {
        let __self = this;
        if (type == "day" && sliderValue > 15) __self.value.sliderValue = 0;
      },
      SelectTime() {
        let __self = this;
        let timePicker = __self.$refs.timePicker;
        timePicker.show();
      },
    },

    watch: {
      Companys(New, Old) {
        let __self = this;
        if (New) {
          New.forEach(o => {
            o.label = o.RoleName;
            o.value = o.RoleID;
          });
          if (__self.value.OwnerID == "") {
            __self.$refs.picker.setSelectedIndex([0]);
          } else {
            let result = _.findIndex(New, function(o) {
              return o.RoleID == __self.value.OwnerID;
            });
            if (result < 0) {
              result = 0;
              __self.$refs.picker.setSelectedIndex([result]);
              __self.selectedText.push(__self.Companys[result]);
            } else {
              __self.$refs.picker.setSelectedIndex([result]);
              __self.selectedText.push(__self.Companys[result]);
            }
          }
          __self.$refs.picker.setData([__self.Companys]);
        }
      },
    },

    components: {
      range,
      picker,
      calendar,
      timePicker,
    },
  };
</script>
